export default {
  "b2b.rezervace.casovy-plan.page-heading": "Časový plán",
  "b2b.rezervace.vytvoreni.page-heading": "Nová rezervace"
};
